import { gql } from 'graphql-request'

export const GetUsuarioLogadoQueryName = 'GetUsuarioLogadoQuery'

export const usuarioLogadoQueryGql = gql`
  query GetUsuarioLogadoQuery {
    usuarioLogado {
      id
      nome
      avatarLink
      marcas {
        id
        description
        facebookId
      }
      tipo {
        id
      }
      idioma {
        id
      }
      funcionalidades {
        id
        chave
      }
      gruposUsuarios {
        id
        nome
      }
    }
  }
`
